import request from '../_helpers/request';
import * as constantsConfig from "../constants/config";
const locale = constantsConfig.localeOptions;
const showid = constantsConfig.showid;
const showCode = constantsConfig.showcode;
const prefix = constantsConfig.webresources_prefix;

export const webResourcesService = {
    GetWebResourcesValue_byPrefix
};

function GetWebResourcesValue_byPrefix(langid, isrefresh) {
    var url = "EMPBackend/GetWebresources";
    var params = {"showid":showid, "showCode":showCode, "langid":langid, "prefix":prefix, "isrefresh": isrefresh};

    return request.post(url, params)
        .then(res => {
            if (res.data) {
                return res.data;
            } else {
                return error;
            }
        })

}